export default "__VITE_ASSET__DUYOERlz__"